export enum FN_GRID_ACTION_TYPE_ENUM {
	ADD = 'ADD',
	UPDATE = 'UPDATE',
	DELETE = 'DELETE',
	REFRESH = 'REFRESH',
	CLEAR_SEARCH = 'CLEAR_SEARCH',
}

export type FN_GRID_ACTION_TYPE =
	| FN_GRID_ACTION_TYPE_ENUM.ADD
	| FN_GRID_ACTION_TYPE_ENUM.UPDATE
	| FN_GRID_ACTION_TYPE_ENUM.DELETE
	| FN_GRID_ACTION_TYPE_ENUM.REFRESH
	| FN_GRID_ACTION_TYPE_ENUM.CLEAR_SEARCH;

export enum FN_GRID_EXPORT_ENUM {
	CSV = 'CSV',
	EXCEL = 'EXCEL',
	PDF = 'PDF',
}

export type FN_GRID_EXPORT_TYPE =
	| FN_GRID_EXPORT_ENUM.CSV
	| FN_GRID_EXPORT_ENUM.EXCEL
	| FN_GRID_EXPORT_ENUM.PDF;

export enum FN_GRID_COMPONENT_TYPE_ENUM {
	TEXT = 'TEXT',
	NUMBER = 'NUMBER',
	PHONE_NUMBER = 'PHONE_NUMBER',
	EMAIL = 'EMAIL',
	TEXTAREA = 'TEXTAREA',
	RATTING = 'RATTING',
	COLOR = 'COLOR',
	IMAGE = 'IMAGE',
	CURRENCY = 'CURRENCY',
	BOOLEAN = 'BOOLEAN',
	DATE = 'DATE',
	LOOKUP = 'LOOKUP',
}
